import Navbar from '../../components/navbar/navbar'
import './notFound.scss'

const NotFound = () => {
  return (
    <>
      <Navbar />
      <div className="page-not-found">
        <h1>404 - Page not found!</h1>
        <h2>
          Go to <a href="/home">Homepage</a>
        </h2>
      </div>
    </>
  )
}
export default NotFound
